var GoogleMaps = {};
GoogleMaps.geocodeAddress = function (address, callback) {
  var geocoder = new google.maps.Geocoder();
  geocoder.geocode({address: address}, function (results, status) {
    if (status === 'OK' && results[0]) {
      callback(results);
    } else {
      callback(status);
    }
  });
};